export default __webpack_public_path__ + "images/814a0ed72ad2d40828df8f806dabdc7a-state_government.jpg";